export const BROWSE_COURSES_ROUTES = {
    LIBRARY: { path: '/library' },
    COURSES: { path: '/courses' },
};
